import React from "react";
import * as bp from "@blueprintjs/core";

export type ExportFn = {
    label: string
    fn: () => Promise<void> | void
};

type ActionBarProps = {
    create?: () => void,
    // Legacy single export button (src-only). Kept for compatibility.
    export?: () => void,
    // New decompiled API: multiple export actions.
    exports?: ExportFn[],
    openMap?: () => void,
    reset?: () => void,
    results?: number,
    openAll?: () => void,
    // Bulk actions
    selectedCount?: number,
    bulkArchive?: () => void,
    bulkUnarchive?: () => void
};

function ActionsBarImpl(props: ActionBarProps = {}) {
    const hasExports = (props.exports && props.exports.length > 0) || !!props.export;
    const combinedExports: ExportFn[] | undefined = props.exports ?? (props.export ? [{label: 'Export', fn: props.export}] : undefined);
    return <section>
        <bp.Card elevation={bp.Elevation.TWO}>
            <bp.ButtonGroup>
                {props.create &&
                    <bp.Button intent={bp.Intent.SUCCESS}
                               outlined
                               icon="new-object"
                               text="Erstellen"
                               onClick={props.create}/>}                

                {props.openMap &&
                    <bp.Button intent={bp.Intent.PRIMARY}
                               outlined
                               icon="map-marker"
                               text="Karte"
                               onClick={props.openMap}/>}

                {hasExports && <bp.ButtonGroup>
                    {combinedExports!.map(({label, fn}) => (
                        <bp.AnchorButton key={label}
                                         icon="download"
                                         intent={bp.Intent.PRIMARY}
                                         outlined
                                         disabled={props.results === 0}
                                         text={label}
                                         onClick={fn}/>
                    ))}
                </bp.ButtonGroup>}

                {props.selectedCount && props.selectedCount > 0 && (
                    <bp.ButtonGroup>
                        {props.bulkArchive && (
                            <bp.Button
                                icon="archive"
                                intent={bp.Intent.WARNING}
                                outlined
                                text={`Archivieren (${props.selectedCount})`}
                                onClick={props.bulkArchive}
                            />
                        )}
                        {props.bulkUnarchive && (
                            <bp.Button
                                icon="undo"
                                intent={bp.Intent.PRIMARY}
                                outlined
                                text={`Entarchivieren (${props.selectedCount})`}
                                onClick={props.bulkUnarchive}
                            />
                        )}
                    </bp.ButtonGroup>
                )}

                {props.reset &&
                    <bp.Button intent={bp.Intent.WARNING}
                               outlined
                               icon="reset"
                               text="Filter zurücksetzen"
                               onClick={props.reset}/>}
                {props.openAll &&
                    <bp.Button intent={bp.Intent.PRIMARY}
                               outlined
                               icon="map"
                               text="Übersichtskarte"
                               onClick={props.openAll}/>}
            </bp.ButtonGroup>
            <bp.Divider/>
            {!!props.results && <p>{props.results} Ergebnisse</p>}
        </bp.Card>
    </section>;
}

// Named export to match decompiled usage
export function ActionsBar(props: ActionBarProps = {}) {
    return <ActionsBarImpl {...props}/>;
}

// Default export to preserve existing imports in src/*
export default function ActionsBarDefault(props: ActionBarProps = {}) {
    return <ActionsBarImpl {...props}/>;
}